const ActionTypes = {
  INIT: 'INIT',
  HEADER_FOOTER: {
    FETCH_PAGE_SHELL_REQUEST: 'FETCH_PAGE_SHELL_REQUEST',
    FETCH_PAGE_SHELL_SUCCESS: 'FETCH_PAGE_SHELL_SUCCESS',
    // GET_NUMBER_OF_ORDER_ITEMS_REQUEST: 'GET_NUMBER_OF_ORDER_ITEMS_REQUEST',
    // GET_NUMBER_OF_ORDER_ITEMS_SUCCESS: 'GET_NUMBER_OF_ORDER_ITEMS_SUCCESS'
  },
  API_REQUEST: 'API_REQUEST',
  API_SUCCESS: 'API_SUCCESS',
  API_ERROR: 'API_ERROR',
  AUTH: {
    SET_USER_PROFILE_FROM_TN_ACCOUNT: 'SET_USER_PROFILE_FROM_TN_ACCOUNT',
    LOGOUT_FROM_TN_ACCOUNT: 'LOGOUT_FROM_TN_ACCOUNT'
  },
  SESSION_DATA: {
    GET: `GET`,
    SET: `SET`,
    REMOVE: `REMOVE`,
    SHOULD_CALL_LOGIN: "SHOULD_CALL_LOGIN"
  },
}

export default ActionTypes
